/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Undelivered/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Undelivered({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info/MessageStatus/Undelivered",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Undelivered.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="tiny"
 color="rgba(0,0,0,0.7)"
 text="Undelivered"
/>
</button>
{children}
</React.Fragment>)
}